import { useEffect, useState } from 'react';

import Button from '../../../components/Button/Button';
import Spots from '../../../components/Spots/Spots';
import SpotGenerator from '../../../components/Spots/SpotGenerator';

import './Hero.css';

export default function Hero() {
    const [leftSpots, setLeftSpots] = useState([]);
    const [rightSpots, setRightSpots] = useState([]);

    useEffect(() => {
        let active = true;

        Promise.all([
            SpotGenerator.generate('hero-left'),
            SpotGenerator.generate('hero-right'),
        ]).then(([left, right]) => {
            if (!active) return;
            setLeftSpots(left);
            setRightSpots(right);
        });

        return () => {
            active = false;
        };
    }, []);

    function translate() {
        document.getElementById('callBack')?.scrollIntoView({ behavior: 'smooth' });
    }

    return (
        <section id='hero' className='hero'>
            <Spots spots={leftSpots} top='46%' left={-420} className='hero_spot hero_spot--left' aria-hidden='true' />
            <Spots spots={rightSpots} top='18%' left={350} spotDelay={1.4} className='hero_spot hero_spot--right' aria-hidden='true' />

            <div className='hero_content'>
                <h1 className='hero_title'>
                    <span className='hero_title_first'>Создаем будущее</span>
                </h1>
                <div className='hero_text'>
                    <p>{'//'} Мы не ждем будущее — мы его пишем строчками</p>
                    <p>кода, мегабайтами идей и терабайтами решений.</p>
                </div>
                <Button onClick={translate}>Связаться с нами</Button>
            </div>
        </section>
    );
}
